import * as authAPI from "app/api/authenticationAPI";
import { TextInput } from "app/components/FormInputs/FormInputs";
import LoadingSpinner from "app/components/LoadingSpinner/LoadingSpinner";
import Modal from "app/components/Modal/Modal";
import isEmpty from "lodash/isEmpty";
import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import Recaptcha from "../Recaptcha/Recaptcha";
import "./AuthScreenForgottenUsernameModal.scss";

type Props = {
  forgottenUsernameActive: boolean;
  I18n: any;
  closeModal: Function;
  handleChange: Function;
  submitForgottenUsername: Function;
  submittingForgottenUsername: boolean;
};

const AuthScreenForgottenUsernameModal = (props: Props): JSX.Element => {
  const [email, setEmail] = useState("");
  const [submittingForgottenUsername, setSubmittingForgottenUsername] =
    useState(false);
  const [forgottenUsernameError, setForgottenUsernameError] = useState("");
  const [forgottenUsernameSuccess, setForgottenUsernameSuccess] = useState("");
  const [token, setToken] = useState("");
  const [verified, setIsVerified] = useState(false);

  const handleVerify = response => {
    setToken(response);
  };

  const handleExpire = () => {
    setIsVerified(false);
  };

  const submitForgottenUsername = (e: React.FormEvent) => {
    e.preventDefault();
    if (isEmpty(email)) return;

    // show loading spinner
    setSubmittingForgottenUsername(true);
    authAPI
      .submitForgottenUsername(email, token)
      .then((resp: any) => {
        setSubmittingForgottenUsername(false);
        setForgottenUsernameSuccess(resp);
        return resp;
      })
      .catch((error: any) => {
        setForgottenUsernameError(
          error.response?.data?.message !== undefined
            ? error.response.data.message
            : error.message
        );
        setSubmittingForgottenUsername(false);
        return error;
      });
  };

  const updateEmail = (id: string, value: string) => {
    setEmail(value);
  };

  const { forgottenUsernameActive, I18n, closeModal } = props;

  return (
    <Modal
      modalOpen={forgottenUsernameActive}
      closeModal={closeModal}
      contentLabel="Password Reset"
      cancelButton
      className="auth-screen__username-modal"
    >
      <form>
        <h1>
          <FormattedMessage tagName="span" id="login-retrieve-username" />
        </h1>
        <span className="username-modal-message">
          {" "}
          <FormattedMessage tagName="span" id="home-username-modal-message" />
        </span>
        <TextInput
          type="email"
          id="email"
          className="auth-screen__form__input"
          removeDefaultStyle={true}
          label={I18n.email}
          onChange={updateEmail}
        />
        <span className="error-msg">{forgottenUsernameError}</span>
        <span className="success-msg">{forgottenUsernameSuccess}</span>
        <div className="auth-screen__form__recaptcha">
          <Recaptcha onVerify={handleVerify} onExpire={handleExpire} />
        </div>
        <div className="auth-screen__form__submit auth-screen__form__submit-no-set-height">
          <button
            id="submit_forgotten_username_button"
            type="submit"
            disabled={false}
            onClick={submitForgottenUsername}
            className={"resend-button"}
          >
            <FormattedMessage tagName="span" id="button-submit" />
            {submittingForgottenUsername ? <LoadingSpinner /> : ""}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default React.memo(AuthScreenForgottenUsernameModal);
